import { reactive } from "vue";
import type { SummaryView } from "../components/summary/summary";

/**
 * UI state shared between Vue components and app.ts.
 * Only plain data goes in here - never Babylon objects (those stay on ctx).
 */
export const appStore = reactive({
    /** Full-screen loader is shown */
    loading: false,
    /** Construction errors for the current module, shown in the viewport */
    errors: [] as string[],
    /** The page currently shown (set by showPage in app.ts) */
    page: "",
    /** Counts every showPage(), so components can react to a page being shown again */
    pageVisits: 0,
    /** Project being edited in the edit project modal */
    editProjectId: null as string | null,
    /** Summary page content (set by updateSummary in app.ts) */
    summary: null as SummaryView | null,
    /** Thumbnail of the configuration on the summary page (updated whenever a thumbnail is rendered) */
    summaryThumbnail: "",
    /** Viewport: the still image shown over the 3D view while a module is rebuilt */
    loadingCanvas: false,
    /** Configurations of the current project, shown as tiles next to the 3D view (set by app.ts) */
    configurations: {
        items: [] as { id: string; thumbnail: string }[],
        activeId: "",
        /** A project can hold at most 4 configurations */
        canAdd: false,
    },
    /** The Vue-owned modal that is open, if any */
    modal: null as AppModal | null,
    /** Header state (set by the page flow in app.ts) */
    header: {
        backButton: false,
        summaryButton: false,
        summaryButtonDisabled: false,
        userMenu: false,
        /** Series name + price block next to the summary button */
        summaryMenu: false,
        seriesName: "",
        priceValue: "",
        priceCurrency: "",
        userName: "",
        /** Logo links to the start page (not in B2C mode) */
        logoLink: false,
        /** B2C mode: no user menu and no prices */
        isB2C: false,
    },
});

export type AppModal = "changePassword" | "forgotPassword" | "forgotPasswordConfirmation" | "resetPasswordConfirmation"
    | "createProject" | "editProject" | "materialGroup" | "options" | "placement" | "order";

export function addError(error: string) {
    if (!appStore.errors.includes(error)) {
        appStore.errors.push(error);
    }
}

export function resetErrors() {
    appStore.errors.splice(0);
}
